import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import FlightSearchBar from "../components/FlightSearchBar";
import TravelDeals from "../components/TravelDeals";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import { useSearchContext } from "../context/SearchContext";

// Custom SVG Icons
const FlightIcon = ({ color = "#fff" }) => (
  <svg
    viewBox="0 0 200 200"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <path
      fill={color}
      d="M178.081 41.973c-2.681 2.663-16.065 17.416-28.956 30.221c0 107.916 3.558 99.815-14.555 117.807l-14.358-60.402l-14.67-14.572c-38.873 38.606-33.015 8.711-33.015 45.669c.037 8.071-3.373 13.38-8.263 18.237L50.66 148.39l-30.751-13.513c10.094-10.017 15.609-8.207 39.488-8.207c8.127-16.666 18.173-23.81 26.033-31.62L70.79 80.509L10 66.269c17.153-17.039 6.638-13.895 118.396-13.895c12.96-12.873 26.882-27.703 29.574-30.377c7.745-7.692 28.017-14.357 31.205-11.191c3.187 3.166-3.349 23.474-11.094 31.167zm-13.674 42.469l-8.099 8.027v23.58c17.508-17.55 21.963-17.767 8.099-31.607zm-48.125-47.923c-13.678-13.652-12.642-10.828-32.152 8.57h23.625l8.527-8.57z"
    />
  </svg>
);

const StaysIcon = ({ color = "#181A1B" }) => (
  <svg
    viewBox="0 0 200 200"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <path
      fill={color}
      d="M166.666 44.998v40.438h-6.078c-2.927-7.642-10.155-13.048-18.607-13.048H123.68c-8.452 0-15.68 5.406-18.607 13.048H94.927C92 77.794 84.772 72.388 76.32 72.388H58.019c-8.452 0-15.68 5.406-18.607 13.048H33.33V44.998h133.336zM180 113.749c0-10.387-7.445-18.982-17.131-20.414H37.131C27.44 94.767 20 103.362 20 113.749v41.253h13.33v-20.627h133.336v20.627H180v-41.253z"
    />
  </svg>
);

const CarsIcon = ({ color = "#181A1B" }) => (
  <svg
    viewBox="0 0 200 200"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <path
      fill={color}
      d="M22.613 84.516C15.647 84.516 10 78.883 10 71.935h12.613c6.966 0 12.613 5.632 12.613 12.581H22.613zm154.774-12.581c-6.966 0-12.613 5.632-12.613 12.581h12.613c6.966 0 12.613-5.633 12.613-12.581h-12.613zm-14.97 13.387c17.991 23.752 15.201 5.722 15.201 74.678h-25.226v-15.484H46.638V160H22.382c0-61.366-3.522-57.158 15.26-75.027C52.259 31.161 56.599 40 127.818 40c25.287 0 29.864 27.733 34.599 45.322zM51.402 84.63h97.104c-10.46-38.739-5.871-32.049-76.037-32.049c-14.277 0-17.559 19.369-21.067 32.049zm9.619 26.983c0-6.948-5.647-12.581-12.613-12.581H35.796c0 6.948 5.647 12.581 12.613 12.581h12.612zm60.705 11.613H78.169a4.374 4.374 0 0 0-4.132 5.791c1.318 4.014 1.759 2.919 47.794 2.919c5.718-.001 5.891-8.71-.105-8.71zm42.479-24.194h-12.574c-6.944 0-12.613 5.655-12.613 12.581h12.574c6.944 0 12.613-5.654 12.613-12.581z"
    />
  </svg>
);

const PackagesIcon = ({ color = "#181A1B" }) => (
  <svg
    viewBox="0 0 200 200"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <path
      fill={color}
      d="M157.952 96.997c6.587-23.706 7.897-44.46 4.27-58.735c21.469 15.807 32.083 43.166 26.147 69.806l-30.417-11.071zm-33.65-71.949C98.32 24.07 73.444 38.069 61.141 61.761l29.201 10.628c10.043-22.067 22.168-38.629 33.96-47.341zM167.5 152.5h-64.222l24.267-66.571l22.224 8.089c7.814-28.622 6.856-50.857 1.101-61.029c-3.617-3.015-3.281-3.53-11.699-5.766c-11.068 2.509-27.356 19.292-40.644 48.145l17.85 6.497l-25.75 70.635H32.5C20.074 152.5 10 162.574 10 175h180c0-12.426-10.074-22.5-22.5-22.5z"
    />
  </svg>
);

const KayakAiIcon = ({ color = "#181A1B" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 200 200"
    role="presentation"
  >
    <path
      fill={color}
      d="M 115.231 75.457 C 91.876 71.115 73.612 52.702 69.271 29.498 C 69.12 28.299 67.46 28.299 67.324 29.498 C 62.982 52.851 44.569 71.115 21.366 75.352 C 20.167 75.608 20.167 77.253 21.366 77.404 C 44.718 81.745 62.982 100.159 67.324 123.363 C 67.475 124.56 69.12 124.56 69.271 123.363 C 73.612 100.009 92.026 81.745 115.231 77.404 C 116.428 77.253 116.428 75.756 115.231 75.457 Z"
    />
    <path
      fill={color}
      d="M 131.81 148.07 C 120.11 145.87 110.91 136.67 108.71 124.97 C 108.61 124.37 107.81 124.37 107.71 124.97 C 105.51 136.67 96.31 145.87 84.61 148.07 C 84.01 148.17 84.01 148.97 84.61 149.07 C 96.31 151.26 105.51 160.47 107.71 172.17 C 107.81 172.77 108.61 172.77 108.71 172.17 C 110.91 160.47 120.11 151.27 131.81 149.07 C 132.31 148.97 132.31 148.17 131.81 148.07 Z"
    />
    <path
      fill={color}
      d="M 179.61 91.87 C 164.01 88.97 151.81 76.67 148.91 61.17 C 148.81 60.37 147.7 60.37 147.61 61.17 C 144.71 76.77 132.41 88.97 116.91 91.8 C 116.11 91.97 116.11 93.07 116.91 93.17 C 132.51 96.07 144.71 108.37 147.61 123.87 C 147.71 124.67 148.81 124.67 148.91 123.87 C 151.81 108.27 164.11 96.07 179.61 93.17 C 180.41 93.07 180.41 92.07 179.61 91.87 Z"
    />
  </svg>
);

function LandingPage() {
  const { 
    from, setFrom,
    to, setTo,
    departureDate, setDepartureDate,
    returnDate, setReturnDate,
    adults, setAdults,
    carryOnBags, setCarryOnBags,
    checkedBags, setCheckedBags,
    tripType, setTripType,
    cabin, setCabin,
    directOnly, setDirectOnly,
    flightSegments, setFlightSegments,
  } = useSearchContext();
  
  const navigate = useNavigate();
  const [pressedButton, setPressedButton] = useState(null);

  const handleButtonPress = (buttonName) => {
    setPressedButton(buttonName);
    setTimeout(() => setPressedButton(null), 150);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/results");
  };

  // Calculate extra height for multi-city flights
  const extraHeight = (flightSegments.length - 1) * 90;

  return (
    <Box
      className="main-body"
      sx={{ background: "#fff !important", minHeight: "100vh", p: 0 }}
    >
      <Header 
        showSearchBar={false}
      />
      <Box sx={{ px: { xs: 1, md: 0 } }}>
       <Box sx={{ background: "#f0f3f5",mx:2, borderRadius: "12px" }}>
       <Paper
          elevation={3}
          data-search-section
          sx={{
            width: "100%",
            height: { xs: "auto", md: `${441 + extraHeight}px` },
            m: 0,
            background: "#f0f3f5",
            color: "#192024",
            borderRadius: { xs: 0, lg: "12px" },
            boxShadow: "none",
            p: 0,
            display: "flex",
            gap: 2,
            justifyContent: "space-between",
            overflow: "hidden",
            transition: "height 0.3s ease-in-out", // Smooth height transition
            position: "relative",
            maxWidth: "none",
            flexDirection: { xs: "column", md: "row" },
            margin: "0 auto",
            maxWidth: "1800px",
          }}
        >
          <Box sx={{ flex: 1, p: { xs: 3, md: 6 }, maxWidth: { xs: "100%", md: 1000 }, position: "relative", zIndex: 1 }}>
            <Typography
              variant="h2"
              fontWeight={800}
              fontSize={{ xs: 28, sm: 32, md: 40 }}
              mb={4}
              textAlign="left"
              lineHeight={1.1}
              noWrap
              sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
            >
              Compare flight deals from 100s of sites
              <span style={{ color: "#ff6600" }}>.</span>
            </Typography>
            <Stack direction="row" spacing={{ xs: 2, md: 4 }} mb={4}>
              <Stack alignItems="center">
                <Button
                  variant="contained"
                  color="warning"
                  sx={{
                    borderRadius: 2,
                    width: 44,
                    height: 44,
                    boxShadow: 1,
                    minWidth: 0,
                    p: 0,
                    opacity: pressedButton === "Flights" ? 0.7 : 1,
                    transform:
                      pressedButton === "Flights" ? "scale(0.95)" : "scale(1)",
                  }}
                  onClick={() => handleButtonPress("Flights")}
                >
                  <FlightIcon
                    color={pressedButton === "Flights" ? "#fff" : "#fff"}
                  />
                </Button>
                <Typography fontSize={14} mt={1} color="#222" fontWeight={500}>
                  Flights
                </Typography>
              </Stack>
              <Stack alignItems="center">
                <Button
                  variant="contained"
                  sx={{
                    background: "#fff",
                    color: "#222",
                    borderRadius: 2,
                    width: 44,
                    height: 44,
                    boxShadow: 1,
                    minWidth: 0,
                    p: 0,
                    opacity: pressedButton === "Stays" ? 0.7 : 1,
                    transform:
                      pressedButton === "Stays" ? "scale(0.95)" : "scale(1)",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                  onClick={() => handleButtonPress("Stays")}
                >
                  <StaysIcon
                    color={pressedButton === "Stays" ? "#fff" : "#181A1B"}
                  />
                </Button>
                <Typography fontSize={14} mt={1} color="#222" fontWeight={500}>
                  Stays
                </Typography>
              </Stack>
              <Stack alignItems="center">
                <Button
                  variant="contained"
                  sx={{
                    background: "#fff",
                    color: "#222",
                    borderRadius: 2,
                    width: 44,
                    height: 44,
                    boxShadow: 1,
                    minWidth: 0,
                    p: 0,
                    opacity: pressedButton === "Cars" ? 0.7 : 1,
                    transform:
                      pressedButton === "Cars" ? "scale(0.95)" : "scale(1)",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                  onClick={() => handleButtonPress("Cars")}
                >
                  <CarsIcon
                    color={pressedButton === "Cars" ? "#fff" : "#181A1B"}
                  />
                </Button>
                <Typography fontSize={14} mt={1} color="#222" fontWeight={500}>
                  Cars
                </Typography>
              </Stack>
              <Stack alignItems="center">
                <Button
                  variant="contained"
                  sx={{
                    background: "#fff",
                    color: "#222",
                    borderRadius: 2,
                    width: 44,
                    height: 44,
                    boxShadow: 1,
                    minWidth: 0,
                    p: 0,
                    opacity: pressedButton === "Packages" ? 0.7 : 1,
                    transform:
                      pressedButton === "Packages" ? "scale(0.95)" : "scale(1)",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                  onClick={() => handleButtonPress("Packages")}
                >
                  <PackagesIcon
                    color={pressedButton === "Packages" ? "#fff" : "#181A1B"}
                  />
                </Button>
                <Typography fontSize={14} mt={1} color="#222" fontWeight={500}>
                  Packages
                </Typography>
              </Stack>
              <Stack alignItems="center">
                <Button
                  variant="contained"
                  sx={{
                    background: "#fff",
                    color: "#222",
                    borderRadius: 2,
                    width: 44,
                    height: 44,
                    boxShadow: 1,
                    minWidth: 0,
                    p: 0,
                    opacity: pressedButton === "KAYAK.ai" ? 0.7 : 1,
                    transform:
                      pressedButton === "KAYAK.ai" ? "scale(0.95)" : "scale(1)",
                    "&:hover": { background: "#f5f5f5" },
                  }}
                  onClick={() => handleButtonPress("KAYAK.ai")}
                >
                  <KayakAiIcon
                    color={pressedButton === "KAYAK.ai" ? "#fff" : "#181A1B"}
                  />
                </Button>
                <Typography fontSize={14} mt={1} color="#222" fontWeight={500}>
                  KAYAK.ai
                </Typography>
              </Stack>
            </Stack>
            {/* Dropdowns above search bar */}
            <FlightSearchBar
              initialFrom={from}
              initialTo={to}
              initialDepartureDate={departureDate}
              initialReturnDate={returnDate}
              initialAdults={adults}
              initialBags={checkedBags}
              initialTripType={tripType}
              initialCabin={cabin}
              initialDirectOnly={directOnly}
              onFlightSegmentsChange={(segments) => {
                setFlightSegments(segments);
              }}
              onTripTypeChange={(newTripType) => {
                setTripType(newTripType);
                if (newTripType !== "Multi-city") {
                  setFlightSegments([
                    {
                      id: 1,
                      from: from[0] || "",
                      to: to[0] || "",
                      date: departureDate,
                      cabin: cabin,
                    }
                  ]);
                }
              }}
              onSubmit={({
                from,
                to,
                departureDate,
                returnDate,
                adults,
                bags,
                tripType,
                cabin,
                directOnly,
                flightSegments,
              }) => {
                console.log("LandingPage onSubmit received:", { from, to, departureDate, returnDate, adults, bags, tripType, cabin, directOnly, flightSegments });
                setFrom(from);
                setTo(to);
                setDepartureDate(departureDate);
                setReturnDate(returnDate);
                setAdults(adults);
                setCheckedBags(bags);
                setTripType(tripType);
                setCabin(cabin);
                setDirectOnly(directOnly);
                if (flightSegments) {
                  setFlightSegments(flightSegments);
                }
                navigate("/results");
              }}
              buttonLabel="Search"
            />
          </Box>
          {/* Right: Images */}
          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              width: { lg: 360, xl: 464 },
              height: { lg: 760, xl: 1000 },
              position: { lg: "absolute" },
              top: { lg: -120, xl: -160 },
              right: { lg: -40, xl: -120 },
              columnGap: "24px",
              flexDirection: "row",
              justifyContent: "space-between",
              zIndex: 0,
            }}
          >
            {/* Left Column */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "24px", flex: 1 }}>
              <img
                src="./kayak01.png"
                alt="Flight 1"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
              <img
                src="./kayak02.png"
                alt="Flight 2"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
              <img
                src="./kayak03.png"
                alt="Flight 3"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
              <img
                src="./kayak04.png"
                alt="Flight 4"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* Right Column */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "24px", flex: 1 }}>
              <img
                src="./kayak05.png"
                alt="Flight 5"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
              <img
                src="./kayak06.png"
                alt="Flight 6"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
              <img
                src="./kayak01.png"
                alt="Flight 7"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
              <img
                src="./kayak02.png"
                alt="Flight 8"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Box>
        </Paper>
       </Box>
      </Box>
      {/* Feature Cards Row */}
      <Box
        sx={{
          mt: 6,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          padding: { xs: "0 12px", sm: "0 16px", md: "0 24px", lg: "0 30px" },
          gap: "8px",
          mb: 8,
          maxWidth: 1740,
          mx: "auto",
        }}
      >
        {/* Card 1: Airline Logos */}
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1 416px",
            minWidth: "248px",
            border: "1px solid #d9e2e8",
            borderRadius: "32px",
            backgroundColor: "#fff",
            color: "#192024",
            p: 4,
            boxSizing: "border-box",
            fontFamily:
              '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 1.231,
            WebkitFontSmoothing: "antialiased",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            {[
              // Airline logos from the HTML
              "https://content.r9cdn.net/rimg/provider-logos/airlines/v/DL.png?crop=false&width=108&height=92&fallback=default1.png&_v=02a9af26513d796d51e54147426d15b5",
              "https://content.r9cdn.net/rimg/provider-logos/airlines/v/QR.png?crop=false&width=108&height=92&fallback=default2.png&_v=be0f8c67c82c1283165869b3d092292f",
              "https://content.r9cdn.net/rimg/provider-logos/airlines/v/AGODAFLIGHTS.png?crop=false&width=108&height=92&fallback=default1.png&_v=f03282fa0de5e32884f896b9fefb109e",
              "https://content.r9cdn.net/rimg/provider-logos/airlines/v/AA.png?crop=false&width=108&height=92&fallback=default2.png&_v=8c6d0e40bdbaad9c51e737b05c12347f",
              "https://content.r9cdn.net/rimg/provider-logos/airlines/v/EY.png?crop=false&width=108&height=92&fallback=default3.png&_v=09081ef33ef8189db98ceb290f923187",
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                alt="airline logo"
                width={40}
                height={40}
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: 8,
                  border: "1px solid #eee",
                  background: "#fff",
                  boxShadow: "0 1px 4px #e0e0e0",
                }}
              />
            ))}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "#181A1B",
                fontFamily:
                  '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                fontWeight: 700,
                fontSize: 24,
                lineHeight: 1.231,
                WebkitFontSmoothing: "antialiased",
              }}
            >
              Save when you compare
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#192024",
                fontFamily:
                  '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                fontWeight: 400,
                fontSize: 14,
                lineHeight: 1.231,
                WebkitFontSmoothing: "antialiased",
                opacity: 0.8,
              }}
            >
              More deals. More sites. One search
            </Typography>
          </Box>
        </Paper>
        {/* Card 2: Avatars and Searches */}
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1 416px",
            minWidth: "248px",
            border: "1px solid #d9e2e8",
            borderRadius: "32px",
            backgroundColor: "#fff",
            color: "#192024",
            p: 4,
            boxSizing: "border-box",
            fontFamily:
              '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 1.231,
            WebkitFontSmoothing: "antialiased",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            {[
              // Avatars
              "https://randomuser.me/api/portraits/women/44.jpg",
              "https://randomuser.me/api/portraits/men/32.jpg",
              "https://randomuser.me/api/portraits/men/65.jpg",
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                alt="avatar"
                width={40}
                height={40}
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: 8,
                  border: "2px solid #fff",
                  boxShadow: "0 1px 4px #e0e0e0",
                }}
              />
            ))}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "#181A1B",
                fontFamily:
                  '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                fontWeight: 700,
                fontSize: 24,
                lineHeight: 1.231,
                WebkitFontSmoothing: "antialiased",
              }}
            >
              41,000,000+
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#192024",
                fontFamily:
                  '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                fontWeight: 400,
                fontSize: 14,
                lineHeight: 1.231,
                WebkitFontSmoothing: "antialiased",
                opacity: 0.8,
              }}
            >
              searches this week
            </Typography>
          </Box>
        </Paper>
        {/* Card 3: Stars and Ratings */}
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flex: "1 1 416px",
            minWidth: "248px",
            border: "1px solid #d9e2e8",
            borderRadius: "32px",
            backgroundColor: "#fff",
            color: "#192024",
            p: 4,
            boxSizing: "border-box",
            fontFamily:
              '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            fontWeight: 400,
            fontSize: 16,
            lineHeight: 1.231,
            WebkitFontSmoothing: "antialiased",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            {[...Array(5)].map((_, i) => (
              <svg
                key={i}
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="#FFA726"
                style={{ marginRight: 4 }}
              >
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
            ))}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "#181A1B",
                fontFamily:
                  '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                fontWeight: 700,
                fontSize: 24,
                lineHeight: 1.231,
                WebkitFontSmoothing: "antialiased",
              }}
            >
              Travelers love us
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#192024",
                fontFamily:
                  '"TT Hoves Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                fontWeight: 400,
                fontSize: 14,
                lineHeight: 1.231,
                WebkitFontSmoothing: "antialiased",
                opacity: 0.8,
              }}
            >
              1M+ ratings on our app
            </Typography>
          </Box>
        </Paper>
      </Box>
      {/* Travel Deals Section */}
      <Box sx={{ mt: 6, backgroundColor: '#f9fafb' }}>
        <TravelDeals />
      </Box>
    </Box>
  );
}

export default LandingPage; 
